import { isOlderThan100Years } from './isOlderThan100Years'
import { isPurchaseDateInTheFuture } from './isPurchaseDateInTheFuture'
import { ValidationResponse } from '../types'
import { error, success } from '../utils'

import { MonthYearDateObject } from 'types'

export enum ValidationErrorType {
  RealDateError = 'realDateError',
  FutureDateError = 'futureDateError',
  MissingMonthError = 'missingMonthError',
  MissingYearError = 'missingYearError',
  MissingFieldError = 'missingFieldError',
}

export const purchaseDateValidationMessages: Record<ValidationErrorType, string> = {
  [ValidationErrorType.MissingMonthError]: 'Date of purchase must include a month',
  [ValidationErrorType.MissingYearError]: 'Date of purchase must include a year',
  [ValidationErrorType.RealDateError]: 'Date of purchase must be a real date',
  [ValidationErrorType.FutureDateError]: 'Date of purchase must be today or in the past',
  [ValidationErrorType.MissingFieldError]: 'Enter when the vehicle was bought',
}

export const purchaseDateValidator = (
  purchaseDate: Partial<MonthYearDateObject>,
): ValidationResponse<ValidationErrorType> => {
  if (!purchaseDate) {
    return error(ValidationErrorType.MissingFieldError)
  }

  const { month, year } = purchaseDate

  const numberMonth = Number(month)
  const numberYear = Number(year)
  const monthIsNaN = isNaN(Number(month))
  const yearIsNaN = isNaN(Number(year))

  if (!month && !year) {
    return error(ValidationErrorType.MissingFieldError)
  }

  if (!month) {
    return error(ValidationErrorType.MissingMonthError)
  }

  if (!year) {
    return error(ValidationErrorType.MissingYearError)
  }

  if (monthIsNaN || yearIsNaN || isOlderThan100Years(Number(numberYear))) {
    return error(ValidationErrorType.RealDateError)
  }

  if (numberMonth < 1 || numberMonth > 12) {
    return error(ValidationErrorType.RealDateError)
  }

  if (isPurchaseDateInTheFuture({ month: numberMonth, year: numberYear })) {
    return error(ValidationErrorType.FutureDateError)
  }

  return success()
}
